import Image from "next/image";
import { cn } from "lib/utils";
import GhostImage from "public/images/ghost-results.png";
import NoResultsSadImage from "public/images/no-results-sad.png";
import NoResultsImage from "public/images/no-results.png";
import { useTranslation } from "react-i18next";

interface PropTypes {
  text?: any;
  action?: any;
  onTab?: boolean;
  ghostImage?: boolean;
  sadImage?: boolean;
}

export default function NoResults({
  text,
  action,
  onTab = false,
  ghostImage = false,
  sadImage = false,
}: PropTypes) {
  const { t } = useTranslation();

  return (
    <section
      className={cn(
        "flex flex-col justify-center items-center text-center gap-8 mx-0 my-16",
        onTab ? "m-0" : ""
      )}
    >
      <div className="relative w-[234px] h-[195px] md:w-[304px] md:h-[265px]">
        <Image
          alt="no_results_image"
          className="contain"
          fill
          priority
          quality={100}
          src={
            ghostImage
              ? GhostImage
              : sadImage
                ? NoResultsSadImage
                : NoResultsImage
          }
        />
      </div>
      <div className="flex flex-col justify-center items-center gap-4 text-[#4a4a4a] font-light leading-6 max-w-[300px]">
        <h4 className="p-0 m-0 font-normal text-[#005c8a]">
          {text || t("no_results")}
        </h4>
        {action ? action : null}
      </div>
    </section>
  );
}
